import React, { useEffect, useMemo } from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { findStopsImage } from "./findStopsImage";

function useDLSelection2() {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);

  const isCombo = doorType?.includes("Combo");

  const addDL = useStore((state) => state.quote.addDL);

  const liteConfig = useStore((state) => state.quote.liteConfig);

  const comboMatchHorizontalSdlBars = useStore((state) => state.quote.comboMatchHorizontalSdlBars);

  const sLite = useStore((state) => state.quote.sideLite);
  const swingSidelite =
    (doorType === "Swing" || doorType === "Pivot") && sLite !== "none";

  const equalPanels = useStore((state) => state.quote.equalPanels);
  const equalPanelsChecked = equalPanels ? true : false;

  const material = useStore((state) => state.quote.material);

  const stickingStops = useStore((state) => state.quote.stickingStops);
  const stickingStopsInterior = useStore((state) => state.quote.stickingStopsInterior);
  const stickingStopsExterior = useStore((state) => state.quote.stickingStopsExterior);
  const sdlExteriorShape = useStore((state) => state.quote.sdlExteriorShape);

  const materialChoice = useStore((state) => state.quote.material);

  const daylightOpening = useStore((state) => state.quote.daylightOpening);

  const dlLayout = useStore((state) => state.quote.dlLayout);
  const dlLayoutSidelite = useStore((state) => state.quote.dlLayoutSidelite);

  const sideliteSdl = useStore((state) => state.quote.diffSideliteSdl);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const isSDL = addDL === "Add SDL";

  const text = isSDL
    ? "Simulated Divided Lites"
    : doorType === "Pivot"
    ? "Intermediate Rail"
    : "True Divided Lites";

  const displayedDl = useMemo(() => findStopsImage({
      door: doorType,
      material,
      isSDL,
      stickingStops: stickingStops || "",
      stickingStopsInterior: stickingStopsInterior || "",
      stickingStopsExterior: stickingStopsExterior || "",
      sdlExteriorShape: sdlExteriorShape || "",
      liteConfig: liteConfig || "",
    }), [stickingStopsInterior, stickingStopsExterior, isSDL, stickingStops, liteConfig, sdlExteriorShape]);

  const handleCheck = (
    e: React.ChangeEvent<{ checked: boolean }>,
    name: string
  ) => {
    const { checked } = e.target;

    addToQuote({
      diffSideliteSdl: name === "no" && checked ? true : false,
    });

    if (findRequired("Sidelite Divided Lites Configuration"))
      removeRequired("Sidelite Divided Lites Configuration");
  };

  const handleCheckComboMatch = (
    e: React.ChangeEvent<{ checked: boolean }>,
    name: string
  ) => {
    const { checked } = e.target;

    addToQuote({
      comboMatchHorizontalSdlBars: name === "yes" && checked ? true : false,
    });
  };

  useEffect(() => {
    if (!swingSidelite || sideliteSdl === null) return;
    if (equalPanelsChecked) addToQuote({ diffSideliteSdl: false });
  }, [swingSidelite, equalPanels]);

  return {
    handleCheck,
    displayedDl,
    text,
    materialChoice,
    daylightOpening,
    dlLayout,
    dlLayoutSidelite,
    sideliteSdl,
    swingSidelite,
    equalPanelsChecked,
    addDL,
    handleCheckComboMatch,
    isCombo,
    comboMatchHorizontalSdlBars,
    liteConfig,
    sdlExteriorShape
  };
}

export default useDLSelection2;
